import { useUxPreference } from '@/hooks/useUxPreference'
import { DashboardResponsive } from './DashboardResponsive'
import { DashboardMobileFirst } from './DashboardMobileFirst'
import { DashboardAdaptive } from './DashboardAdaptive'

const DashboardPage = () => {
  const { preference } = useUxPreference()

  if (preference === 'mobile-first') return <DashboardMobileFirst />
  if (preference === 'adaptive') return <DashboardAdaptive />
  return <DashboardResponsive />
}

export default DashboardPage
